// extracted by mini-css-extract-plugin
export var subtitle = "_9w-2";
export var title = "_9w-0";
export var titleNoWrap = "_9w-1";